<template>
  <el-row>
    <el-col :span="4">
      <el-menu router active-text-color="#409eff" :default-openeds="['/doc/index']" :default-active="active">
        <el-submenu index="/doc/index">
          <template slot="title">
            <span>API列表</span>
          </template>
            <el-menu-item index="/doc/index">签名机制</el-menu-item>
            <el-menu-item index="/doc/sign-request">发起企业合同签署</el-menu-item>
            <el-menu-item index="/doc/sign-request-v2">发起企业合同签署（v2）</el-menu-item>
            <el-menu-item index="/doc/sign-success-notify">签署成功通知</el-menu-item>
            <el-menu-item index="/doc/contract-invalid">作废合同</el-menu-item>
            <el-menu-item index="/doc/contract-status">查询签署状态</el-menu-item>
        </el-submenu>
        <el-menu-item index="/doc/template-search">
          <span slot="title">模板查询</span>
        </el-menu-item>
        <el-menu-item index="/doc/sdk">
          <span slot="title">SDK下载</span>
        </el-menu-item>
      </el-menu>
    </el-col>
    <el-col :span="20">
      <router-view/>
    </el-col>
  </el-row>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      active:'/doc/index'
    };
  },
  mounted(){

    this.active = this.$route.path
  }
};
</script>

<style scoped>
  .el-row {
    margin: 0 80px
  }
  .el-menu{
    border-right:none
  }
</style>
